module.exports = __webpack_public_path__ + "static/media/18ECA47.46ca4ea3.jpg";